import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, matches } from 'lodash'; import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import { formFields, confirmationMessage, successfullyMessage, userFormFields, options, statusOptions, countryLengthConstant, countryCodeConstant } from './constant';
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import routes from '../../../../routes';
import Table from '../../../../components/CustomTable';
import Input from '../../../../components/FormElements/Input';
import SelectNew from '../../../../components/FormElements/SelectNew'
import { withRouter, Link } from 'react-router-dom';
import { editAccountAction, postAddThirdPartySeatAction, postBalanceValueAction, getAdminUserSingleListAction, postUserMappedSeatsAction, postAllTenantsFetchBalanceAction } from '../../../../actions';
import { useFetchPlatformData } from "../../../../hooks/useFetchPlatformData";
import { sortArray } from "../../../../selectors";
import { checkTablePermission } from "../../../../utils/route-auth";
import { PERMISSION } from "../../../../constants/permission";

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const CampaignSync = asyncRoute(() => import('../../../../components/CampaignSync'));

function ViewAccount(props) {
    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });

    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});
    const [submited, setSubmited] = useState(false);
    const [form, setForm] = useState({});
    const [balance, setBalance] = useState(0);
    const [userList, setUserList] = useState([]);
    const [seatData, setSeatData] = useState([]);
    const [creditBalance, setCreditBalance] = useState(null);
    const [campaignSyncVisible, setCampaignSyncVisible] = useState(false);
    const [selectedCampaignSyncAccount, setSelectedCampaignSyncAccount] = useState({});
    const [parentTenant, setParentTenant] = useState({});
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const configurationList = useSelector((state) => get(state, "app.configurationData.responseList", []));
    const rolesList = useSelector((state) => get(state, "app.adminRolesData.responseList", []));
    const tenantList = useSelector((state) => get(state, "app.preSignInData.responseList", []));
    const accountTypeList = get(configurationList.find(item => item.attrName === 'TENANT_TYPE'), 'attributeValues', []);
    const platformData = useFetchPlatformData();
    const { match: { params: { id } } } = props;

    const platformListOptions = useMemo(() => {
        return (
            checkTablePermission({ edit: PERMISSION.ADMIN.CONNECTIONMANAGEMENT.EDIT }, {
                columns: [
                    { id: 1, name: '', label: '', sortable: false, },
                    { id: 2, name: 'platform', label: 'PLATFORM', sortable: false, type: 'string', component: (row) => (<div>{platformData && platformData.find(platform => platform.key == row.platformId).value}</div>) },
                    { id: 3, name: 'accountName', label: 'ACCOUNT NAME', sortable: true, type: 'string', component: (row) => (<div>{row.accountName ? row.accountName : row.displayName}</div>) },
                    {
                        id: 4, name: 'accountId', label: 'ACCOUNT ID', sortable: true, type: 'number',
                    },
                    {
                        id: 5, name: 'currency', label: 'CURRENCY', sortable: true, type: 'string', component: (row) => (<div>{row.currency}</div>)
                    },
                    { id: 6, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => row.isRecActive == 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
                ],
                keyCol: 'aId',
                actions: [
                    {
                        type: 'sync',
                        text: '',
                        icon: 'ti ti-refresh color-beki',
                        tooltip: 'Sync',
                        iconType: 'new'
                    },
                ],
                recActive: true,
                showSwitch: true,
                status: {
                    key: 'isRecActive',
                    active: '1',
                    activeIcon: 'ti ti-toggle-left color-beki ti-lg',
                    inActiveIcon: 'ti ti-toggle-right color-beki ti-lg',
                    confirmation: true,
                    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
                    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
                    type: 'recActive'
                },
                actionsThead: true,
                sortable: false,
                dateType: true,
                defaultSortParams: {
                    sortBy: 'BaseCurrency',
                    sortOrder: 'desc'
                },
                showSearch: false,
                searchable: true,
                searchColumns: [
                    { key: 'AlternateCurrency' }
                ],
                paging: true,
                defaultPagingParams: {
                    pageSize: 25
                }
            })
        )
    }, [platformData]);

    const dispatch = useDispatch();
    const toast = (status, msg) => {
        setToastModal({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newForm = { ...form };
        newForm[e.target.name] = value;
        setForm(newForm);
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const handleAction = (row, action) => {
        const { match, history } = props;
        if (action.type === 'recActive') {
            // handleStatus(row, action);
        }
    }

    const getAccountDetails = async (advertiserId) => {
        let accountDetails;
        await dispatch(editAccountAction({ tenantId, authToken, userId, editId: advertiserId }))
            .then((data) => {
                const { responseCode: { status }, responseList } = data;
                if (status.toLowerCase() == "success") {
                    accountDetails = responseList[0];
                    if (accountDetails && accountDetails.user && accountDetails.user.length > 0) {
                        accountDetails.user.map(item => {
                            item.isActive = item.roleTenantList[0].isActive
                            return item;
                        });
                    }
                } else {
                    console.log("Advertiser Details Not Found!");
                }
            }).catch((error) => {
                console.error(error);
            });
        return accountDetails;
    }

    const getAccountBalance = async (payload) => {
        await dispatch(postBalanceValueAction({ tenantId, authToken, userId, payload }))
            .then((data) => {
                const { responseCode: { status = '' }, response } = data;
                if (response && response.balance) {
                    setBalance(response.balance);
                }
            }).catch((error) => {
                console.error(error);
            });
    }

    const getParentTenant = () => {
        let tenantNamesList = _.map(tenantList, (item) => ({ id: item.tenantId, text: item.tenantName }));
        const currentTenantType = tenantList.find(item => item.tenantId == tenantId)
        const parentTenant = tenantNamesList.find(item => item.id == currentTenantType.parentTenantId);
        setParentTenant(parentTenant);
    };

    const editId = async (id) => {
        let accountDetails = await getAccountDetails(id);
        setUserList(accountDetails.user);
        const newForm = { ...form, ...accountDetails };
        newForm['advertiserName'] = newForm.accountName;
        newForm['status'] = newForm.isActive;
        newForm[formFields.accountOwnerName.key] = accountDetails.contactPerson && accountDetails.contactPerson;
        newForm[formFields.accountOwnerEmail.key] = accountDetails.email && accountDetails.email;
        setForm(prevState => ({
            ...prevState,
            ...newForm
        }));
        if (accountDetails) {
            let payload = { tenantId: accountDetails && accountDetails.accTenantId };
            await getAccountBalance(payload);
        }
    }

    const getSeatData = async () => {
        const { match: { params: { id } } } = props;
        let params = { list: 'mapped' };
        let payload = {
            thirdPartySeatRequest: {
                advertiserId: id
            }
        };
        await dispatch(postUserMappedSeatsAction({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const { responseCode: { status }, response } = data;
                if (status.toLowerCase() == "success") {
                    setSeatData(response);
                } else {
                    console.log("Users mapped seats not found!");
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    const handleMappedSeatStatus = async (row) => {
        let params = { addup: row.id };
        let payload = {
            thirdPartySeatRequest: {
                ...row,
                isRecActive: row.isRecActive == 1 ? 0 : 1
            }
        };
        await dispatch(postAddThirdPartySeatAction({ tenantId, authToken, userId, params, payload }))
            .then((data) => {
                const { responseCode: { msg, status = '' }, responseObj } = data;
                if (status.toLowerCase() == "success" && responseObj && Object.keys(responseObj).length > 0) {
                    console.log(responseObj);
                    toast(status, msg);
                }
            }).catch((error) => {
                console.error(error);
            });
    };

    // const getUserDetails = async () => {
    //     await dispatch(getAdminUserSingleListAction({ tenantId, authToken, userId, id: userId }))
    //         .then((data) => {
    //             const { responseCode: { status = '' }, response, responseList } = data;
    //             if (status && status.toLowerCase() == "success" && responseList && responseList.length > 0) {
    //                 setForm(prevState => ({
    //                     ...prevState,
    //                     accountOwnerName: responseList[0].name,
    //                     accountOwnerEmail: responseList[0].email
    //                 }));
    //             }
    //         }).catch((error) => {
    //             console.error(error);
    //         });
    // };

    const handlePlatformTableAction = (row, action) => {
        if (action.type === 'recActive') {
            handleMappedSeatStatus(row);
        } else if (action.type === 'sync') {
            setCampaignSyncVisible(true);
            setSelectedCampaignSyncAccount(row);
        }
    };

    useEffect(() => {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = props;
            history.push(routes.preSignIn);
        }
    }, []);

    useEffect(() => {
        const { match: { params: { id } } } = props;
        if (id) {
            editId(id);
            getSeatData();
        }
    }, []);

    useEffect(() => {
        const { match: { params: { id } } } = props;
        if (id && tenantList && tenantList.length > 0) {
            getParentTenant();
        }
    }, [tenantList]);

    return (
        <>
            <div className="main-panel ion form__style">
                <div className="content-wrapper">
                    <div className="row justify-content-center m-3">
                        <div className="col-md-12 px-0">
                            <div className="card">
                                <div className="p-4 m-2">
                                    <div className="col-md-6 pr-4">
                                        <div className="form-group row">
                                            <label className="col-md-6 px-0">Agency:</label>
                                            <select disabled className='form-select'>
                                                <option>{ parentTenant && parentTenant.text}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.advertiserName.key] ? form[formFields.advertiserName.key] : ''}
                                                setting={formFields[formFields.advertiserName.key]}
                                                error={errors[formFields.advertiserName.key]}
                                                submited={submited}
                                                touched={touched[formFields.advertiserName.key]}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <SelectNew
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountType.key]}
                                                setting={formFields[formFields.accountType.key]}
                                                error={errors[formFields.accountType.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountType.key]}
                                                options={accountTypeList}
                                                disabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountOwnerName.key] ? form[formFields.accountOwnerName.key] : ''}
                                                setting={formFields[formFields.accountOwnerName.key]}
                                                error={errors[formFields.accountOwnerName.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountOwnerName.key]}
                                                disabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.accountOwnerEmail.key] ? form[formFields.accountOwnerEmail.key] : ''}
                                                setting={formFields[formFields.accountOwnerEmail.key]}
                                                error={errors[formFields.accountOwnerEmail.key]}
                                                submited={submited}
                                                touched={touched[formFields.accountOwnerEmail.key]}
                                                disabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6 ">
                                            <SelectNew
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={form[formFields.status.key]}
                                                setting={formFields[formFields.status.key]}
                                                error={errors[formFields.status.key]}
                                                submited={submited}
                                                touched={touched[formFields.status.key]}
                                                options={sortArray((formFields[formFields.status.key]).options)}
                                                disabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6 ">
                                            <Input
                                                onChange={handleChange}
                                                onBlur={handleTouch}
                                                value={balance}
                                                setting={formFields[formFields.addCredit.key]}
                                                error={errors[formFields.addCredit.key]}
                                                submited={submited}
                                                touched={touched[formFields.addCredit.key]}
                                                disabled={true}
                                            />
                                            {/* {
                                                (creditBalance !== null && creditBalance !== undefined) ? < p className="text-primary">Current Credit Bal : {creditBalance}</p>
                                                    :
                                                    null
                                            } */}
                                        </div>
                                    </div>

                                    {
                                        userList && userList.length > 0 &&
                                        <div className="mt-3">
                                            <h5 className="pt-2 font-weight-bold">Access allowed to Users</h5>
                                            <div style={{ padding: '0.5rem 0' }}>
                                                <div className='campaign-adj'>
                                                    <div className="campaign-list-adj table-responsive">
                                                        <Table
                                                            options={options}
                                                            data={userList}
                                                            handelAction={handleAction}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        seatData && seatData.length > 0 &&
                                        <div className="my-3" style={{ padding: '0.5rem 0' }}>
                                            <div className='campaign-adj'>
                                                <div className="campaign-list-adj table-responsive">
                                                    <Table
                                                        options={platformListOptions}
                                                        data={seatData}
                                                        handelAction={handlePlatformTableAction}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {campaignSyncVisible && <CampaignSync selectedCampaignSyncAccount={selectedCampaignSyncAccount} onClose={() => setCampaignSyncVisible(false)} onSave={() => getSeatData()} isAdvertisers={false} createdTenantId={id} props={props} />}

                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 py-4 d-flex border justify-content-end" style={{ background: '#F7F8FC', borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }}>
                            <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.account.name}`} className="btn mx-3" style={{ borderRadius: '0.5rem', border: '1px solid #DCE3EE', background: '#FFF', padding: '0.625rem 1.125rem' }}>
                                <span className="text-primary">Close</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default withRouter(ViewAccount);